import { AppLanguage } from 'app/config/i18Config/types';
import { AppRoutes } from 'app/config/routerConfig/types';

export const CLIENT_DATE_FORMAT = 'DD.MM.YYYY';

export const SERVER_DATE_FORMAT = 'YYYY-MM-DD';

export const CLIENT_DATE_WITH_TIME_FORMAT = 'DD.MM.YYYY HH:mm:ss';

export const APP_NAME = process.env.REACT_APP_NAME;

export const APP_LANGUAGE_KEY = `${process.env.REACT_APP_NAME}-language`;

export const languageToLabelMap: Record<AppLanguage, string> = {
  [AppLanguage.en]: 'English',
  [AppLanguage.de]: 'Deutsch',
  [AppLanguage.pl]: 'Polski',
  [AppLanguage.ru]: 'Русский',
};

export const languageToShortLabelMap: Record<AppLanguage, string> = {
  [AppLanguage.en]: 'EN',
  [AppLanguage.de]: 'DE',
  [AppLanguage.pl]: 'PL',
  [AppLanguage.ru]: 'РУ',
};

export const routeTitleMap: Record<string, string> = {
  [AppRoutes.HOME]: 'Home',
  [AppRoutes.LOGIN]: 'Login',
  [AppRoutes.FORGOT_PASSWORD]: 'Forgot password',
  [AppRoutes.RESET_PASSWORD]: 'Reset password',
  [AppRoutes.WAREHOUSES]: 'Warehouses',
  [AppRoutes.CITIES]: 'Cities',
  [AppRoutes.USERS]: 'Users',
  [AppRoutes.CONTRACTS]: 'Contracts',
  [AppRoutes.PAYMENTS]: 'Payments',
  [AppRoutes.NOTES]: 'Notes',
  [AppRoutes.TASKS]: 'Tasks',
  [AppRoutes.GENERAL]: 'General',
  [AppRoutes.BOOKING]: 'Booking',
  [AppRoutes.MY_BOXES]: 'My bookings',
  [AppRoutes.GLOBAL_SETTINGS]: 'Global settings',
  [AppRoutes.CHECKOUT]: 'Checkout',
  [AppRoutes.PAYMENT_SUCCESS]: 'Payment success',
  [AppRoutes.PAYMENT_FAILED]: 'Payment failed',
  [AppRoutes.BOXES]: 'Boxes',
  [AppRoutes.INVOICES]: 'Invoices',
  [AppRoutes.CREDIT_NOTES]: 'Credit notes',
  [AppRoutes.INSURANCE]: 'Insurance',
  [AppRoutes.RESERVATIONS]: 'Reservations',
  [AppRoutes.ADMIN_PANEL]: 'Admin panel',
  [AppRoutes.LATE_CHARGE_SETTINGS]: 'Late charge settings',
  [`${AppRoutes.PROFILE}/:userId`]: 'Profile',
  [AppRoutes.BILLING_DOCUMENTS]: 'Billing documents',
  [AppRoutes.INSURANCE_SETTINGS]: 'Insurance settings',
  [AppRoutes.DEPOSITS]: 'Deposits',
  [AppRoutes.NO_RESULT]: 'No result',
  [AppRoutes.STATISTICS]: 'Statistics',
  [AppRoutes.BOXES_OCCUPANCY]: 'Boxes occupancy',
  [AppRoutes.INCOME_STATISTICS]: 'Income statistics',
  [AppRoutes.LOGIN_PROCESS_PAGE]: 'Login process',
  [AppRoutes.DISCOUNTS]: 'Discounts',
  [`${AppRoutes.PROFILE}/:userId/account`]: 'My account',
  [`${AppRoutes.PROFILE}/:userId/latest-activity`]: 'Latest activity',
  [`${AppRoutes.PROFILE}/:userId/invoices`]: 'My Invoices',
  [`${AppRoutes.MY_BOXES}/:warehouseId`]: 'My bookings',
};
